export default {
  // Splash & Onboarding
  "welcome": "Welcome",
  "onboarding1_title": "Safe & Fast Transport",
  "onboarding1_desc": "Vehicle and cargo transport service with modern flatbeds and best drivers",
  "onboarding2_title": "Live Tracking",
  "onboarding2_desc": "Track your flatbed location in real-time until your vehicle arrives safely",
  "onboarding3_title": "Transparent Pricing",
  "onboarding3_desc": "Get instant quote before confirming your order with no surprises",
  "next": "Next",
  "skip": "Skip",
  "get_started": "Get Started",
  
  // Language
  "select_language": "Select Language",
  "arabic": "العربية",
  "english": "English",
  "continue": "Continue",
  
  // Auth
  "login": "Login",
  "phone_number": "Phone Number",
  "enter_phone": "Enter your phone number",
  "send_code": "Send Code",
  "enter_otp": "Enter Verification Code",
  "otp_sent": "Verification code sent to",
  "verify": "Verify",
  "resend_code": "Resend Code",
  "guest_mode": "Continue as Guest",
  "guest_explore": "Explore all features",
  
  // Home
  "home": "Home",
  "orders": "Orders",
  "profile": "Profile",
  "where_pickup": "Where to pickup?",
  "where_dropoff": "Where to dropoff?",
  "use_current_location": "Use Current Location",
  "saved_addresses": "Saved Addresses",
  "home_address": "Home",
  "work_address": "Work",
  "search_address": "Search for address...",
  "request_flatbed": "Request Flatbed",
  
  // Order Details
  "order_details": "Order Details",
  "vehicle_info": "Vehicle Information",
  "vehicle_type": "Vehicle Type",
  "select_type": "Select Type",
  "car": "Car",
  "suv": "SUV",
  "truck": "Small Truck",
  "heavy_truck": "Heavy Truck",
  "motorcycle": "Motorcycle",
  "vehicle_model": "Vehicle Model",
  "enter_model": "Enter model",
  "upload_photos": "Upload Vehicle Photos",
  "front_photo": "Front Photo",
  "back_photo": "Back Photo",
  "side_photo": "Side Photo",
  "add_photo": "Add Photo",
  "notes": "Additional Notes",
  "enter_notes": "Add any special notes...",
  "get_quote": "Get Quote",
  
  // Instant Quote
  "instant_quote": "Instant Quote",
  "distance": "Distance",
  "km": "km",
  "estimated_time": "Estimated Time",
  "minutes": "minutes",
  "base_price": "Base Price",
  "sar": "SAR",
  "additional_services": "Additional Services",
  "winch_service": "Winch Service",
  "vehicle_cover": "Vehicle Cover",
  "insurance": "Additional Insurance",
  "total_price": "Total Price",
  "confirm_order": "Confirm Order",
  "edit_details": "Edit Details",
  
  // Finding Driver
  "finding_driver": "Finding Driver...",
  "please_wait": "Please Wait",
  "searching_nearest": "Searching for nearest available driver",
  
  // Driver Accepted
  "driver_accepted": "Driver Accepted",
  "driver_info": "Driver Information",
  "rating": "Rating",
  "flatbed_type": "Flatbed Type",
  "plate_number": "Plate Number",
  "call_driver": "Call",
  "chat": "Chat",
  "share_location": "Share Location",
  "order_status": "Order Status",
  "on_the_way": "On the way to you",
  "arrived": "Arrived at location",
  "loading": "Loading",
  "in_transit": "In transit to destination",
  "delivered": "Delivered",
  "track_live": "Live Tracking",
  
  // Trip Complete
  "trip_complete": "Trip Complete",
  "trip_summary": "Trip Summary",
  "pickup_location": "Pickup Location",
  "dropoff_location": "Dropoff Location",
  "trip_duration": "Trip Duration",
  "rate_driver": "Rate Driver",
  "rate_experience": "How was your experience?",
  "add_comment": "Add comment (optional)",
  "submit_rating": "Submit Rating",
  "share_receipt": "Share Receipt",
  "done": "Done",
  
  // Orders List
  "current_orders": "Current Orders",
  "past_orders": "Past Orders",
  "cancelled_orders": "Cancelled Orders",
  "no_orders": "No orders",
  "order_id": "Order ID",
  "status": "Status",
  "view_details": "View Details",
  "pending": "Pending",
  "in_progress": "In Progress",
  "completed": "Completed",
  "cancelled": "Cancelled",
  
  // Profile
  "personal_info": "Personal Information",
  "full_name": "Full Name",
  "email": "Email",
  "saved_locations": "Saved Locations",
  "add_address": "Add Address",
  "notifications": "Notifications",
  "enable_notifications": "Enable Notifications",
  "language": "Language",
  "privacy_policy": "Privacy Policy",
  "terms_conditions": "Terms & Conditions",
  "faq": "FAQ",
  "logout": "Logout",
  "save": "Save",
  "cancel": "Cancel",
  
  // Chat
  "type_message": "Type a message...",
  "send": "Send",
  
  // Errors
  "error_occurred": "Error Occurred",
  "connection_error": "Connection Error",
  "check_connection": "Please check your internet connection",
  "retry": "Retry",
  
  // Common
  "back": "Back",
  "close": "Close",
  "delete": "Delete",
  "edit": "Edit",
  "add": "Add",
  "search": "Search",
  "filter": "Filter",
  "sort": "Sort",
  "apply": "Apply",
  "reset": "Reset",
  "yes": "Yes",
  "no": "No",
  "ok": "OK",
};